const createLabels = (scores, regularGameParts, finalLabel, placeholder) => {
    const scoreLabels = scores.map((el, index) => {
        const currentGamePart = index + 1;
        if (currentGamePart > regularGameParts) {
            return placeholder.replace("{0}", `${currentGamePart - regularGameParts}`);
        }
        return currentGamePart.toString();
    });
    scoreLabels.push(finalLabel);
    return scoreLabels;
};
const shouldCreateLabels = (scores, homeScore, awayScore) => scores.length > 0 || homeScore || awayScore;
export const getBasketballLabels = (sportId, scores, dict, homeScore, awayScore) => {
    const regularGameParts = scores.length % 2 === 0 ? scores.length : scores.length - 1;
    if (shouldCreateLabels(scores, homeScore, awayScore)) {
        return createLabels(scores, regularGameParts, dict.myBetsDictionary.Total, dict.myBetsDictionary.Overtime);
    }
    return [];
};
export const getSoccerLabels = (sportId, scores, dict, homeScore, awayScore) => {
    const regularGameParts = 2;
    if (shouldCreateLabels(scores, homeScore, awayScore)) {
        return createLabels(scores, regularGameParts, "", `${dict.myBetsDictionary.Overtime}{0}`);
    }
    return [];
};
//# sourceMappingURL=createSportLabelsWithOvertime.js.map